import { render, staticRenderFns } from "./Cn-SDS-Oil.vue?vue&type=template&id=52a7f6f9&scoped=true&"
import script from "./Cn-SDS-Oil.vue?vue&type=script&lang=js&"
export * from "./Cn-SDS-Oil.vue?vue&type=script&lang=js&"
import style0 from "./Cn-SDS-Oil.vue?vue&type=style&index=0&id=52a7f6f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7f6f9",
  null
  
)

export default component.exports